import axios from 'axios'

const API_PATH = 'api/v2/admins/tl_warehouse_locations'

const TlWarehouseLocationApiV2 = {
  /**
   * Get list of `District`
   * @param {string} location - location name
   * @param {number} sublocation - sublocation name
   * @return {object} Collection of `Tl Warehouse Locations`
   */
  get: async (location) => {
    const path     = `${API_PATH}?location=${location}`
    const response = axios.get(path)
    return response
  },

  create: async ({ location, sublocation }) => {
    const payload  = {
      location    : location,
      sublocation : sublocation
    }
    const response = axios.post(API_PATH, payload)
    return response
  }
}

export default TlWarehouseLocationApiV2
